import React, { useEffect, useState } from 'react';
import { css } from '@emotion/css';
import { MasonryGrid } from '@egjs/react-grid';

import type { VFC } from 'react';

const photoArray = [
  'images/gallery-01.jpg',
  'images/gallery-02.jpg',
  'images/gallery-03.jpg',
  'images/gallery-04.jpg',
  'images/gallery-05.jpg',
  'images/gallery-06.jpg',
  'images/gallery-07.jpg',
  'images/gallery-08.jpg',
  'images/gallery-09.jpg',
  'images/gallery-10.jpg',
  'images/gallery-11.jpg',
  'images/gallery-12.jpg',
  'images/gallery-13.jpg',
  'images/gallery-14.jpg',
  'images/gallery-15.jpg',
  'images/gallery-16.jpg',
  'images/gallery-17.jpg',
  'images/gallery-18.jpg',
  'images/gallery-19.jpg',
  'images/gallery-20.jpg',
  'images/gallery-21.jpg',
  'images/gallery-22.jpg',
  'images/gallery-23.jpg',
  'images/gallery-24.jpg',
  'images/gallery-25.jpg',
];

const shuffle = ([...array]) => {
  for (let i = array.length - 1; i >= 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const photos = shuffle(photoArray);

const styles = {
  item: css({
    width: 'calc(100% / 3 - ((21px * 2) / 3))',
    backgroundColor: 'transparent',
    border: 0,
    cursor: 'pointer',
  }),

  itemPic: css({
    position: 'relative',

    '& img': {
      objectFit: 'cover',
      objectPosition: 'center center',
      width: '100%',
      height: '100%',
      transition: '.5s ease-in-out',
      opacity: 0,
    },
  }),

  visiblePic: css({
    transform: 'translateY(-50px)',
    opacity: '1 !important',
  }),

  popup: css({
    position: 'fixed',
    backgroundColor: 'rgba(0, 0, 0, .5)',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 11,
  }),

  photo: css({
    maxWidth: '50%',
    maxHeight: '90%',
    position: 'relative',
    width: '100%',
    height: '100%',

    '& img': {
      objectFit: 'contain',
      width: '100%',
      height: '100%',
      objectPosition: 'center center',
    },
  }),

  close: css({
    position: 'absolute',
    right: -15,
    top: -15,
    width: 30,
    height: 30,
    backgroundColor: '#fff',
    border: 0,
    borderRadius: '50%',
    cursor: 'pointer',
    zIndex: 1,
  }),
};

const GalleryMasonry: VFC = () => {
  const [select, setSelect] = useState('');

  const handleSelect = (e) => {
    setSelect(e.currentTarget.value);
  };

  const handleClose = () => {
    setSelect('');
  };

  useEffect(() => {
    const items: any = document.getElementsByClassName(styles.item);
    const observer = new IntersectionObserver((entries, object) => {
      entries.forEach((entry, i) => {
        if (!entry.isIntersecting) return false;

        const item = entry.target;

        item.getElementsByTagName('img')[0].classList.add(styles.visiblePic);

        object.unobserve(item);
        return true;
      });
    }, {
      threshold: [0.5],
    });

    [...items].forEach((item) => {
      observer.observe(item);
    });
  }, []);

  return (
    <>
      <MasonryGrid
        className="container"
        gap={20}
        defaultDirection="end"
        align="justify"
      >
        {
          photos.map((photo, index) => (
            <button className={styles.item} type="button" onClick={handleSelect} value={photo} key={index}>
              <div className={styles.itemPic}>
                <img src={photo} alt="" />
              </div>
            </button>
          ))
        }
      </MasonryGrid>
      {
        select && (
          <div className={styles.popup}>
            <div className={styles.photo}>
              <button className={styles.close} type="button" onClick={handleClose}>×</button>
              <img src={select} alt="" />
            </div>
          </div>
        )
      }
    </>
  );
};

export default GalleryMasonry;
